import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "variant", "size", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { forwardRef } from 'react';
import ThemedBox from 'components/ThemedBox';
import { jsx as _jsx } from "react/jsx-runtime";
var variantProps = {
  default: {
    boxShadow: 'soft',
    name: 'card'
  },
  clickable: {
    boxShadow: 'soft',
    boxShadowOnHover: 'softHover',
    name: 'card'
  },
  raised: {
    boxShadow: 'raised',
    name: 'card'
  },
  inverted: {
    boxShadow: 'soft',
    name: 'invertedCard'
  }
};
var Card = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var as = _ref.as,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'large' : _ref$size,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    /*
    Warning!!! `ThemedBox` is currently not being properly typechecked.
    Comment out `otherProps` and `as` when making changes to check types 
             */
    _jsx(ThemedBox, _objectSpread(_objectSpread(_objectSpread({
      ref: ref,
      width: "100%",
      overflow: "hidden",
      as: as || 'div'
    }, otherProps), {}, {
      borderRadius: size
    }, variantProps[variant]), {}, {
      children: children
    }))
  );
});
Card.displayName = 'Card';
export default Card;